import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./asset-list-header.module.scss";
import IconClose from "../../../../dynamicicons/icon-close";
import IconFilterList from "../../../../dynamicicons/icon-filter-list";
import IconSearch from "../../../../dynamicicons/icon-search";
import VelavuIconButton from "../../../../elements/velavu-icon-button";
import VelavuInput from "../../../../elements/velavu-input";
import FloorFilter from "../../../../data/floor-filter";
import FloorFilterButton from "../../../../elements/floor-filter-button";
import whitelabel from "../../../../whitelabel";

export default function AssetListHeader(props: {
	searchText: string;
	setSearchText: (searchText: string) => void;

	selectedFloorNum: number | undefined;
	onChangeFloorFilter: (filter: FloorFilter) => void;
	showFloorFilter: boolean;

	isFiltering: boolean;
	showFilterMenu: boolean;
	onToggleFilterMenu: VoidFunction;
}) {
	const { t } = useTranslation();
	const filterColor = props.isFiltering
		? whitelabel.palette.primary900
		: whitelabel.palette.secondary700;

	return (
		<div className={styles.header}>
			<VelavuInput
				className={styles.search}
				leadingIcon={
					<IconSearch
						size={16}
						color={whitelabel.palette.secondary900}
					/>
				}
				placeholder={t("common.search_assets")}
				value={props.searchText}
				onChange={props.setSearchText}
				fullWidth
			/>

			{props.showFloorFilter && (
				<FloorFilterButton
					selection={props.selectedFloorNum}
					onChange={props.onChangeFloorFilter}
				/>
			)}

			<VelavuIconButton
				highlight={props.isFiltering}
				onClick={props.onToggleFilterMenu}
			>
				{props.showFilterMenu ? (
					<IconClose color={filterColor} />
				) : (
					<IconFilterList color={filterColor} />
				)}
			</VelavuIconButton>
		</div>
	);
}
